import { useMutation } from '@tanstack/react-query'

import { apiRequest } from '../../../../services/api'

const API_ENDPOINT = '/api/stocks-why-moving/rate'

export const useRatingMutation = () => {
  const rateMutation = useMutation({
    mutationFn: ({
      stockWhyMovingHistoryId,
      liked,
      text,
    }: {
      stockWhyMovingHistoryId: number
      liked: boolean
      text?: string
    }) =>
      apiRequest(
        API_ENDPOINT,
        {
          method: 'POST',
          body: JSON.stringify({
            stockWhyMovingHistoryId,
            liked,
            text,
          }),
        },
        true
      ),
  })

  return { rateMutation }
}
